import * as constants from '../constants/ActionTypes';

const initialState = {
  callUsResult: undefined,
  isLoading: true,
  display: false,
  isLogoutToLogin: false,
  chatParams: undefined,
  callUsElmoTreatments: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.REQUEST_CALLUS:
      return { ...state, isLoading: true, display: false };
    case constants.RECEIVE_CALLUS_RESPONSE:
      return {
        ...state,
        callUsResult: action.callUsData,
        isLoading: false,
        display: true,
        callUsElmoTreatments: action.callUsElmoTreatments,
      };
    case constants.RECEIVE_CALLUS_ERROR:
      return { ...state, isLoading: false, display: true };
    case constants.LOGIN_EMAIL:
      return { ...state, display: false, callUsResult: undefined };
    case constants.BACK_TO_CONTACT_HOME:
    case constants.CANCEL_EMAIL_FORM_NO_INTENT:
      return initialState;
    case constants.LOGOUT_TO_LOGIN:
      return { ...state, isLogoutToLogin: action.payload };
    case constants.STORE_CHATBOT_QUERY_PARAMS:
      return { ...state, chatParams: action.payload };
    default:
      return state;
  }
}
